export default {
  getList: state => state.list,
  getNextId: state => state.nextId,
  getDetail: state => state.detail
};
